export default __webpack_public_path__ + "static/media/Commands.d88afb03.yaml";